module.exports = "#searchLink i {\n  margin: 0 auto;\n}\n\n#searchBox select {\n  width: 100%;\n}\n\n#searchBox button {\n  margin: 0 auto;\n}\n\n.modal-header h2 {\n  color: #40c3bf;\n  font-size: 25px;\n}\n\n.modal-body {\n  color: inherit;\n  font-size: 15px;\n  padding: 30px;\n}\n\n.modal-body h2 {\n  color: #40c3bf;\n  font-size: 25px;\n}\n\n.modal-body ul li {\n  display: block;\n  margin-bottom: 20px;\n}\n\n.modal-body select, .modal-body input {\n  width: 100%;\n  padding: 5px;\n}\n\n.modal-body button {\n  margin: 0 auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search/search.component.scss
// module id = ./src/app/shared/search/search.component.scss
// module chunks = main